module.exports = __webpack_public_path__ + "img/browser3.3225a465.png";